// language=HTML
const template = `
    <article class="teams">
        <md-content>
            <h1 class="md-display-2 section-title">Teams</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <md-card class="app-list-card" ng-if="installation.hasTeams">
                <app-loading ng-if="loading" layout-padding></app-loading>

                <md-list ng-if="!loading">
                    <md-list-item ng-repeat="team in teams">
                        <md-icon class="md-avatar-icon">business</md-icon>

                        <p>{{ team.description }}</p>
                    </md-list-item>
                </md-list>
            </md-card>

            <form autocomplete="off" name="form"
                  class="form--create-team"
                  ng-submit="createTeam($event)">

                <md-card class="app-form-card">
                    <md-card-title>
                        <h2>Add a team</h2>
                    </md-card-title>

                    <md-card-content>
                        <app-input-text
                            flex
                            form="form"
                            name="description"
                            label="Description"
                            value="newTeam.description"
                            required>
                        </app-input-text>
                    </md-card-content>

                    <md-card-actions layout="row" layout-align="end">
                        <md-button type="submit"
                                   class="md-primary md-raised"
                                   ng-disabled="form.$invalid">
                            Create Team
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

TeamsController.$inject = ['$app', '$errorHandler', '$installation', '$scope', '$state', '$teamFetcher', '$util'];

function TeamsController($app, $errorHandler, $installation, $scope, $state, $teamFetcher, $util) {
    $scope.installation = $installation;
    $scope.loading = false;
    $scope.newTeam = {
        description: null,
    };
    $scope.teams = [];

    $scope.createTeam = createTeam;

    // Main
    fetchTeams();

    // Functions
    function createTeam() {
        const firstRun = !$installation.hasTeams;
        const toast = $app.progressToast('Creating team');

        $teamFetcher
            .create({ ...$scope.newTeam, assign_all_users: true })
            .then(
                $util.nextTick(response => {
                    $app.successToast('Team created');

                    $scope.teams.push(response.data);

                    $scope.newTeam = {};

                    $scope.form.$invalid = false;

                    $installation.hasTeams = true;

                    if (firstRun) {
                        $state.go($installation.nextStep);
                    }
                }),
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                toast.hide();
            });
    }

    function fetchTeams() {
        $scope.loading = true;

        $teamFetcher
            .all()
            .then(
                response => {
                    $scope.teams = response.data;
                },
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                $scope.loading = false;
            });
    }
}

export { template, TeamsController as controller };
